import React from 'react';
import PublicLayout from '../../components/public/PublicLayout';
import PageHero from '../../components/public/PageHero';
import Accordion from '../../components/public/Accordion';
import { usePageMeta } from '../../publicSite/usePageMeta';
import { admissionsFaqs } from '../../publicSite/admissionsContent';

export default function AdmissionsFaqs() {
  usePageMeta('Admissions FAQs | School of Shem', 'Answers to the most common admissions questions.');

  return (
    <PublicLayout>
      <PageHero
        eyebrow="Admissions"
        title="Admissions FAQs"
        subtitle="Quick answers to help you move forward with confidence."
        image="/images/shem-mentorship.jpg"
        imageAlt="A School of SHEM mentoring conversation"
      />
      <section className="ps-section">
        <div className="ps-section-inner">
          <Accordion items={admissionsFaqs} />
        </div>
      </section>
    </PublicLayout>
  );
}
